import * as React from 'react'
import { useKey, useLockBodyScroll } from 'react-use'
import { useTranslation } from 'hooks'
import { iconCrossM } from 'images'
import { ModalProps } from './Modal.types'
import * as S from './Modal.styles'

const Modal: React.FC<React.PropsWithChildren<ModalProps>> = ({
  children,
  toggleModal,
  css,
  closeOnClickOutside = true,
  closeOnButton = true,
  closeOnEsc = true,
  ...rest
}) => {
  const { t } = useTranslation()

  // Lock body scroll while the modal is mounted (it only mounts while open).
  // `useLockBodyScroll` handles iOS too (a `touchmove` preventDefault listener),
  // which a plain `overflow: hidden` does not — so this must NOT be replaced by
  // a manual `document.body.style.overflow` effect, and `useModal` must not also
  // lock (the two fight, leaving the page permanently unscrollable after close).
  useLockBodyScroll(true)

  useKey('Escape', () => closeOnEsc && toggleModal())

  return (
    <S.StyledModal {...rest} role="presentation">
      <S.ModalBackdrop onClick={() => closeOnClickOutside && toggleModal()}>
        <S.ModalContent
          role="presentation"
          onClick={(e) => e.stopPropagation()}
          onTouchMove={(e) => e.stopPropagation()}
          style={css}
        >
          {closeOnButton && (
            <S.ModalClose onClick={toggleModal}>
              <img src={iconCrossM} alt={t('shared.close')} />
            </S.ModalClose>
          )}

          {children}
        </S.ModalContent>
      </S.ModalBackdrop>
    </S.StyledModal>
  )
}

export default Modal
